import { allColors, statsColors } from '../components/charts/colors'

// Semantic design tokens over the Tellus brand palette (tailwind.config.js).
// tailwind.config.js carries the same hex values as utility aliases; the
// tokens spec asserts the two never drift. JS consumers (charts, inline
// styles) read from here instead of hard-coding hexes.
export const tokens = {
  color: {
    ink: '#051C2C',          // prussian-blue: headings, primary text
    inkMuted: '#6f8998',     // pacific-storm: secondary text
    surface: '#ffffff',
    surfaceMuted: '#f0f3f5', // foggy-morning: page background
    border: '#ccd9e3',       // drizzly-day: card/table borders
    interactive: '#0067a5',  // perfect-shine: links, focus rings, info accents
    primary: '#00436c',      // fine-barrel: the one filled primary button color
    primaryHover: '#002338', // fine-barrel dark
    status: {
      success: '#2e7a54',    // emerald dark
      warning: '#a77820',    // anzac dark
      danger: '#D83527',     // cerise-red
      info: '#0067a5',       // perfect-shine
    },
    chart: {
      series: allColors,
      semantic: statsColors,
    },
  },
  // Mined from the Benchmarks screen (protected reference; audit 2026-07-03):
  // its micro-label and KPI numeral treatments are the suite's polish bar.
  typography: {
    microLabel: 'text-xs font-semibold uppercase tracking-wide',
    kpiNumeral: 'text-3xl font-bold tabular-nums',
  },
  radius: {
    control: 'rounded-md',
    pill: 'rounded-full',
    card: 'rounded-lg',
  },
} as const

export type Tokens = typeof tokens
